export interface IPhxPreviousRoute {
  state: ng.ui.IState;
  params: any;
}

export interface IPhxStateService extends ng.ui.IStateService {
  __previousRoute__: IPhxPreviousRoute;
  __previousRoutes__: IPhxPreviousRoute[];
  __goToPrevious__: () => ng.IPromise<any>;
}

require('utility-ng-log');
require('angular-ui-router');
require('ui-ng-notification');
require('utility-ng-kernel');

angular.module('utility-ng-configuration', [
  'ui.router',
  'utility-ng-log',
  'utility-ng-kernel',
  'ui-ng-notification'
]);

export const Configuration = require('./core/configuration');
require('./configuration/consistent_page_configuration');
require('./configuration/consistent_route_configuration');
require('./configuration/fault_tolerance_configuration');
require('./configuration/network_failure_configuration');
require('./configuration/network_url_configuration');
require('./configuration/notification_configuration');



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-configuration/dist/main.ts